/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Apiurl, GetToken, RemoveUserSession } from "../../../Utils/utils";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import "./LowWorkingHoursAlert.css";

const REFRESH_INTERVAL = 5 * 60 * 1000;

const LowWorkingHoursAlert = () => {
  const [alertData, setAlertData] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const formatTime = (time) => {
  if (!time) return "-";

  const [hours, minutes] = time.split(":");

  return `${parseInt(hours, 10)}h ${minutes}min`;
};

const calculateShortBy = (worked, required) => {
  if (!worked || !required) return "-";

  const [wh, wm] = worked.split(":").map(Number);
  const [rh, rm] = required.split(":").map(Number);

  const workedMinutes = wh * 60 + wm;
  const requiredMinutes = rh * 60 + rm;

  let diff = requiredMinutes - workedMinutes;

  if (diff < 0) diff = 0;

  const hours = Math.floor(diff / 60);
  const minutes = diff % 60;

  return `${hours}h ${minutes.toString().padStart(2, "0")}min`;
};
  
  const navigate = useNavigate();

  const getInitials = (name) => {
    if (!name) return "??";
    return name
      .split(" ")
      .filter((n) => n.length > 0)
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const fetchLowWorkingHours = (showAlert = false) => {
    const LoginToken = GetToken();
    if (!LoginToken) return;

    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Projects/CheckLowWorkingHours`,
    };

    axios(option)
      .then((res) => {
        const employees = res?.data?.data?.employees || [];
        const count = res?.data?.data?.count || 0;
        setAlertData(employees);
        setLastUpdated(new Date());
        if (count > 0 && showAlert) {
          setShowToast(true);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }
      });
  };

  useEffect(() => {
    fetchLowWorkingHours(true);
    const interval = setInterval(() => fetchLowWorkingHours(true), REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  // useEffect(() => {
  //   if (!showToast) return;
  //   const timer = setTimeout(() => setShowToast(false), 8000);
  //   return () => clearTimeout(timer);
  // }, [showToast]);

  const handleToastClick = () => {
    setShowToast(false);
    setShowModal(true);
  };

  if (alertData.length === 0) return null;

  return (
    <>
      {/* ── Toast ── */}
      {showToast && (
        <div className="lwh-toast" onClick={handleToastClick}>
          <div className="lwh-toast-row1">
            <span className="lwh-toast-title">
              <span className="lwh-amber-dot" />
              Low Working Hours Alert
            </span>
            <span className="lwh-toast-time">just now</span>
            <button
              className="lwh-toast-close"
              onClick={(e) => {
                e.stopPropagation();
                setShowToast(false);
              }}
            >
              ×
            </button>
          </div>
          <p className="lwh-toast-sub">
            {alertData.length} record{alertData.length !== 1 ? "s" : ""} found
            with less than required working hours
          </p>
          <p className="lwh-toast-cta">Click to view details →</p>
        </div>
      )}

      {/* ── Modal ── */}
      {showModal && (
        <div className="lwh-overlay" onClick={() => setShowModal(false)}>
          <div className="lwh-modal" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="lwh-modal-head">
              <div>
                <h2>
                  Low Working Hours —{" "}
                  <span className="lwh-count-text">
                    {alertData.length} record{alertData.length !== 1 ? "s" : ""}
                  </span>
                </h2>
                <p>Employees who worked less than required hours (last 10 days)</p>
              </div>
              <button
                className="lwh-modal-close"
                onClick={() => setShowModal(false)}
              >
                ×
              </button>
            </div>

            {/* Body */}
            <div className="lwh-modal-body">
              <table className="lwh-table">
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th>Date</th>
                    <th>Worked</th>
                    <th>Required</th>
                    <th>Short by</th>
                  </tr>
                </thead>
                <tbody>
                  {alertData.map((emp, index) => {
                  const shortBy = calculateShortBy(
  emp?.workedHours,
  emp?.requiredHours
);
                    return (
                      <tr key={index}>
                        <td>
                          <div className="lwh-emp-cell">
                            <div className="lwh-avatar">
                              {getInitials(emp?.userName)}
                            </div>
                            <span>{emp?.userName || "-"}</span>
                          </div>
                        </td>
                        <td>{emp?.date || "-"}</td>
                        <td>
                         <span className="lwh-worked-badge">
  {formatTime(emp?.workedHours)}
</span>
                        </td>
                     <td>{formatTime(emp?.requiredHours)}</td>
                        <td>
                        <span className="lwh-short-badge">
  {shortBy}
</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Footer */}
            <div className="lwh-modal-foot">
              {/* <span>Auto-refreshes every 5 min</span> */}
              <span>
                Last updated:{" "}
                {lastUpdated ? moment(lastUpdated).format("hh:mm A") : "-"}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LowWorkingHoursAlert;